<template>
  <div class="report-kpi" :class="`report-kpi--${tone}`">
    <div class="report-kpi__icon"><i :class="icon"></i></div>
    <div class="report-kpi__content">
      <span class="report-kpi__label">{{ label }}</span>
      <strong class="report-kpi__value">{{ value }}</strong>
      <small v-if="detail" class="report-kpi__detail">{{ detail }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportKpiCard",
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    detail: { type: String, default: "" },
    icon: { type: String, default: "pi pi-chart-line" },
    tone: { type: String, default: "teal" },
  },
};
</script>

<style scoped>
.report-kpi {
  --accent: #0f6f78;
  min-height: 124px;
  padding: 1.15rem;
  border: 1px solid #e4e7ec;
  border-left: 4px solid var(--accent);
  border-radius: 12px;
  background: linear-gradient(145deg, #fff 70%, #f3f8f8);
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  box-shadow: 0 5px 18px rgba(16, 24, 40, 0.06);
}
.report-kpi--amber { --accent: #d88320; }
.report-kpi--blue { --accent: #3969ac; }
.report-kpi--red { --accent: #c8473d; }
.report-kpi--green { --accent: #438a57; }
.report-kpi--purple { --accent: #76559d; }
.report-kpi__icon {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 11px;
  background: #edf7f7;
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}
.report-kpi__content { min-width: 0; display: flex; flex-direction: column; }
.report-kpi__label { color: #667085; font-size: 0.76rem; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase; }
.report-kpi__value { color: #101828; font-size: 1.65rem; line-height: 1.25; margin-top: 0.25rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.report-kpi__detail { color: #667085; margin-top: 0.28rem; }
</style>
